import { FeatureList } from '../Styled';
import { TEST_IDS } from '../../constants';
import { XAILikelyTileFeatureListTypes } from './types';
import { XAILikelyTileFeatureListItem } from './XaiLIkelyTileFeatureListItem';

export const XAILikelyTileFeatureList = ({ features }: XAILikelyTileFeatureListTypes) => {
  return (
    <FeatureList data-test={`${TEST_IDS.XAILikelyFeatureList}`}>
      {features.map((feature) => {
        return <XAILikelyTileFeatureListItem key={feature.name} feature={feature} />;
      })}
    </FeatureList>
  );
};
